import React, {useEffect, useState, useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark, faCircleCheck } from "@fortawesome/free-solid-svg-icons";


const cards =  [
  {
    img: "intelihire/sec-5/1.png",
    icon: "intelihire/sec-5/icons/1.png",
    title: "Never Play Email Tag Again",
    desc: "Candidates select available slots, confirmations go out instantly, and your team stays synced—no back-and-forth required.",
  },
  {
    img: "intelihire/sec-5/2.png",
    icon: "intelihire/sec-5/icons/2.png",
    title: "Hire with Confidence, Not Guesswork",
    desc: "Every decision is backed by data, helping you identify high-potential hires before your competition does.",
  },
  {
    img: "intelihire/sec-5/3.png",
    icon: "intelihire/sec-5/icons/3.png",
    title: "Your Brand, Your Platform",
    desc: "Personalized, secure web and mobile interface that reflects your company identity.",
  },
  {
    img: "intelihire/sec-5/4.png",
    icon: "intelihire/sec-5/icons/4.png",
    title: "Everyone Gets What They Need",
    desc: "Tailored views for recruiters, HR teams, and administrators. Each role sees relevant data and actions—no clutter, no confusion.",
  },
];

const Section5 = ({url}) => {

    const sectionRef = useRef(null);
  const [Slick, setSlick] = useState(null);

  // Prevent multiple loads
    const slickLoaded = useRef(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        async (entries) => {
          const entry = entries[0];
  
          if (entry.isIntersecting && !slickLoaded.current) {
            slickLoaded.current = true; // mark loaded BEFORE loading
  
            // Dynamically load JS + CSS
            const slickModule = await import("react-slick");
            await import("slick-carousel/slick/slick.css");
            await import("slick-carousel/slick/slick-theme.css");
  
            setSlick(() => slickModule.default);
  
            observer.disconnect(); // stop observing forever
          }
        },
        { threshold: 0.2 }
      );
  
      if (sectionRef.current) observer.observe(sectionRef.current);
      return () => observer.disconnect();
    }, []);
  
    const settings = {
      dots: true,              // ✅ dots enabled
      arrows: false,           // ❌ no arrows
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      speed: 600,

      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } }, // ✅ mobile
      ],
    };

  return (

  <section className="home-section-5" ref={sectionRef}>
  <div className="container">

    {/* Heading */}
    <div className="text-center section-header">
      <h2>
        Find Your Perfect Hire in <span>1/10th</span> the Time
      </h2>
      <p className="section-desc">
        AI based recruitment platform automatically ranks, matches, and shortlists candidates <br />
        based on defined skills, experience, and fit.
      </p>
    </div>

    {/* Grid */}
    <div className="features-grid overflow-hidden features-desktop">

      {/* Card 1 */}
      <div className="grid-card" data-aos="fade-up" data-aos-duration="1000">
        <div className="grid-card-image">
          <img src={`${url}images/intelihire/sec-5/1.png`} alt="Email Automation" className="img-fluid" />
        </div>
        <div className="grid-card-content">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-5/icons/1.png`} alt="Email" />
          </div>
          <h5>Never Play Email Tag Again</h5>
          <p>
            Candidates select available slots, confirmations go out instantly, and your
            team stays synced—no back-and-forth required.
          </p>
        </div>
      </div>

      {/* Card 2 */}
      <div className="grid-card" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="150">
        <div className="grid-card-image">
          <img src={`${url}images/intelihire/sec-5/2.png`} alt="Hire with Confidence" className="img-fluid" />
        </div>
        <div className="grid-card-content">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-5/icons/2.png`} alt="Badge" />
          </div>
          <h5>Hire with Confidence, Not Guesswork</h5>
          <p>
            Every decision is backed by data, helping you identify high-potential hires before
            your competition does.
          </p>
        </div>
      </div>

      {/* Card 3 */}
      <div className="grid-card" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
        <div className="grid-card-image">
          <img src={`${url}images/intelihire/sec-5/3.png`} alt="Your Brand" className="img-fluid" />
        </div>
        <div className="grid-card-content">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-5/icons/3.png`} alt="Layers" />
          </div>
          <h5>Your Brand, Your Platform</h5>
          <p>
            Personalized, secure web and mobile interface that reflects your company
            identity.
          </p>
        </div>
      </div>

      {/* Card 4 */}
      <div className="grid-card" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="250">
        <div className="grid-card-image">
          <img src={`${url}images/intelihire/sec-5/4.png`} alt="Everyone Gets What They Need" className="img-fluid" />
        </div>
        <div className="grid-card-content">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-5/icons/4.png`} alt="Thumbs Up" />
          </div>
          <h5>Everyone Gets What They Need</h5>
          <p>
            Tailored views for recruiters, HR teams, and administrators. Each role sees relevant
            data and actions—no clutter, no confusion.
          </p>
        </div>
      </div>

    </div>


    <div className="features-grid mobile-slider d-md-none">
        {Slick ? (
            <Slick {...settings}>
            {cards.map((card, index) => (
                <div key={index} className="slide-item">
                <div className="grid-card">
                    <div className="grid-card-image">
                    <img
                        src={`${url}images/${card.img}`}
                        alt={card.title}
                        className="img-fluid"
                    />
                    </div>
                    <div className="grid-card-content">
                    <div className="icon-box">
                        <img
                        src={`${url}images/${card.icon}`}
                        alt={card.title}
                        />
                    </div>
                    <h5>{card.title}</h5>
                    <p>{card.desc}</p>
                    </div>
                </div>
                </div>
            ))}
            </Slick>
        ) : (
            <div style={{ height: "300px" }}></div>
        )}
    </div>

  </div>
</section>
  );
};

export default Section5;
